import React, { createContext, useContext, useState } from 'react';

const PreWizardContext = createContext();

export const PreWizardProvider = ({ children }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [onButtonClick, setOnButtonClick] = useState(() => null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <PreWizardContext.Provider
            value={{
                selectedOption,
                setSelectedOption,
                isButtonEnabled,
                setIsButtonEnabled,
                onButtonClick,
                setOnButtonClick,
                isSubmitting,
                setIsSubmitting
            }}
        >
            {children}
        </PreWizardContext.Provider>
    );
};

export const usePreWizardContext = () => {
    const context = useContext(PreWizardContext);
    if (!context) {
        throw new Error('usePreWizardContext must be used within PreWizardProvider');
    }
    return context;
};
